import { Task, TaskAggregations, WayPoint } from '@bringg/types';
import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';

let fields: (keyof Task | { way_points: (keyof WayPoint)[] } | { aggregations: (keyof TaskAggregations)[] })[];

const getFields = () => {
	if (!fields) {
		const { configuration } = getRoot<RootStore>().data.merchantConfigurationsStore;
		let addressFields: (keyof WayPoint)[] = ['address', 'city', 'zipcode', 'address_type'];

		if (Array.isArray(configuration.address_format?.values)) {
			addressFields = configuration.address_format.values.map(({ key }) => key) as (keyof WayPoint)[];
		}

		fields = [
			'id',
			'external_id',
			'created_at',
			'title',
			'priority',
			'ready_to_execute',
			'status',
			'run_id',
			'user_id',
			'required_skills',
			'vehicle_id',
			'team_ids',
			'task_type_id',
			'planning_done',
			'fleet_id',
			'late',
			'tag_id',
			'service_plan_id',
			'reserved_until',
			'rank',
			'preparation_ready_for_pickup_time_actual',
			{
				way_points: [
					'id',
					'eta',
					'etos',
					'position',
					'lat',
					'lng',
					'no_earlier_than',
					'first_attempt_promise_no_earlier_than',
					'no_later_than',
					'first_attempt_promise_no_later_than',
					'customer_id',
					'checkin_time',
					'checkout_time',
					'pickup_dropoff_option',
					'ui_data',
					'scheduled_at',
					...addressFields
				]
			},
			{
				aggregations: ['max_weight', 'inventory_total_quantity', 'has_any_rejected_inventory']
			},

			// perf improvement: Added here even though it's not used in the UI because it's gonna be added by the dashboard-sdk,
			// which would change this reference and will prevent us from using the cached hash in the light-data-store.
			// added fields in task sdk
			// task api adding fields: https://github.com/bringg/dashboard-sdk/blob/9d6a35009c8d6f9ca3bb60d830f80647071cb46b/src/Task/v2/tasks-api.ts#L365
			// the sdk caching: https://github.com/bringg/dashboard-sdk/blob/9d6a35009c8d6f9ca3bb60d830f80647071cb46b/src/Data/light-data-store.ts#L8-L17
			'invalidated',
			'group_leader_id'
		];
	}

	return fields;
};

export const fetchFieldsProvider = {
	get: getFields,

	// Use this method to reset the fields cache in tests
	reset() {
		fields = undefined;
	}
};
